import { Directive } from "@angular/core";
import { NzDropDownADirective } from "ng-zorro-antd/dropdown";

@Directive({
  selector: "a[ui-dropdown]",
})
export class UiDropDownADirective extends NzDropDownADirective {}
